
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/page/[page]",
      function () {
        return require("private-next-pages/search/page/[page].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/page/[page]"])
      });
    }
  